import { useState } from 'react'
import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from '@/components/ui/dialog'
import InvestigationForm from '@/frontend/features/Fde/investigations/InvestigationForm'
import type { InvestigationData } from '@/frontend/features/Fde/investigations/types'

export default function NewInvestigation({ data }: { data: InvestigationData }) {
  const [open, setOpen] = useState(false)
  if (!data.can_manage) return null
  return <Dialog open={open} onOpenChange={setOpen}>
    <DialogTrigger asChild><Button size="sm"><Plus className="size-4" aria-hidden />{data.labels.new}</Button></DialogTrigger>
    <DialogContent className="max-h-[90dvh] overflow-y-auto sm:max-w-2xl">
      <DialogHeader><DialogTitle>{data.labels.new}</DialogTitle><DialogDescription>{data.labels.historical_hint}</DialogDescription></DialogHeader>
      <InvestigationForm key={data.project.id} {...data} inDialog onStarted={() => setOpen(false)} />
    </DialogContent>
  </Dialog>
}
